// extracted by mini-css-extract-plugin
module.exports = {"container":"topic-content_container__MoyFI"};